<template lang="">
    <div class="bbs_filter">
      <div class="lft_area">
        <div class="bbs_info">
          <div class="total"><strong>
            {{ getCurrentCount() }}
          </strong> / {{ this.campaignPaymentListCount }}</div>
        </div>
      </div>
      <div class="rgt_area">
        <div class="bbs_srch">
          <select name="" id="" class="i_sel" v-model="searchType">
            <option
              v-for="option in searchOptions"
              :value="option.value"
            >{{ option.name }}</option>
          </select>
          <input type="text" class="i_txt" name="keyword" v-model="searchWord">
          <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
        </div>
      </div>
    </div>
  
    <div class="bbs_list">
      <table class="bbs_tbl">
        <colgroup>
          <col style="width:50px">
          <col style="width:70px">
          <col style="width:150px">
          <col style="width:auto">
          <col style="width:80px">
          <col style="width:100px">
          <col style="width:100px">
          <col style="width:100px">
        </colgroup>
        <thead>
          <tr>
            <th scope="col">번호</th>
            <th scope="col">주문번호</th>
            <th scope="col">캠페인명</th>
            <th scope="col">장례식장명</th>
            <th scope="col">호실</th>
            <th scope="col">후원자</th>
            <th scope="col">운영비</th>
            <th scope="col">일시</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(campaign, index) in campaignPaymentList"
          >
            <td>{{ campaign.order }}</td>
            <td>{{ campaign.orderNum }}</td>
            <td>{{ campaign.campaignName }}</td>
            <td>{{ campaign.funeralLocationName }}</td>
            <td>{{ campaign.funeralLocationDtl }}</td>
            <td>{{ campaign.paymentName }}</td>
            <td class="medium">{{ $addComma(campaign.paymentAmount) }}</td>
            <td>
              <div class="ui_datetime">
                <span class="date">{{ campaign.createDate }}</span>
                <span class="time"></span>     
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <div class="paginate">
      <AdminPagination
        :totalPages = "totalPages()"
        :currentPage = "currentPage"
        @changePage = "changePage"
      />
    </div>
  </template>
  <script>
  import { mapActions, mapState } from 'vuex';
  import AdminPagination from '@/components/common/AdminPagination.vue';
  
  const adminCampaignPaymentModule = 'adminCampaignPaymentModule'
  
  export default {
    components: {
      AdminPagination
    },
  
    data () {
      return {
        currentPage: 1,
        selectedCampaigns: [],
  
        searchOptions: [
          { name: '전체', value: 'all' },
          { name: '주문번호', value: 'orderNum' },
          { name: '장례식장명', value: 'funeralLocationName' },
          { name: '호실', value: 'funeralLocationDtl' },
        ],
        searchType: 'all',
        searchWord: ''
      }
    },
  
    methods: {
      ...mapActions(adminCampaignPaymentModule, [
        'requestCampaignPaymentList',
      ]),
  
      totalPages() {
        return Math.ceil(this.campaignPaymentListCount / 10);
      },

      async changePage(page) {
        this.currentPage = page
        const {currentPage, searchType, searchWord} = this
        await this.requestCampaignPaymentList({currentPage, searchType, searchWord})
      },
  
      getCurrentCount() {
        const currentFirstCount = (this.currentPage - 1) * 10 + 1
        let currentLastCount = this.currentPage * 10
        if (parseInt(currentLastCount) > parseInt(this.campaignPaymentListCount)) {
          currentLastCount = this.campaignPaymentListCount
        }
        return currentFirstCount + '-' + currentLastCount
      },
  
      async getSearch() {
        if (this.searchWord === '') {
          alert('검색어를 입력해주세요')
          return
        }
        this.currentPage = 1
        const {currentPage, searchType, searchWord} = this
        await this.requestCampaignPaymentList({currentPage, searchType, searchWord})
      }
    },
  
    computed: {
      ...mapState(adminCampaignPaymentModule, [
        'campaignPaymentList',
        'campaignPaymentListCount'
      ])
    },
  
    async mounted() {
      const {currentPage, searchType, searchWord} = this
      await this.requestCampaignPaymentList({currentPage, searchType, searchWord})
    }
  }
  </script>
  <style lang="">
      
  </style>